export const concatContent = (content: string[], suffix = '.'): string =>
  (content || [])
    .filter(Boolean) // remove undefined
    .map((a) => `${a}${suffix}`)
    .join(' ');
